export default __webpack_public_path__ + "static/media/map_v.19d34641.mov";